module.exports = __webpack_public_path__ + "static/media/phoneGreen.2f3596f9.svg";